// QNNEAL Language Transformation Layer
// Rule: If a non-technical business owner cannot understand it in 3 seconds, rewrite it.

export const LABELS = {
  // Navigation
  nav_dashboard: "Dashboard",
  nav_optimize: "Optimize",
  nav_agents: "My Agents",
  nav_analytics: "Savings Report",
  nav_integration: "Connect Platforms",
  nav_settings: "Settings",
  nav_billing: "Billing",
  nav_dev_portal: "Dev Portal",

  // Dashboard
  total_spend: "Total Spend",
  total_saved: "Total Saved",
  speed_boost: "Speed Boost",
  optimize_button: "Optimize My Workflow",
  deep_optimize: "Deep Optimization (takes longer, saves more)",

  // Optimization States
  opt_analyzing: "Analyzing your workflow...",
  opt_finding: "Finding the best solution...",
  opt_almost: "Almost done...",
  opt_complete: "Done! You just saved {amount}",

  // Agent Grades
  grade_a: "Excellent — Running efficiently",
  grade_b: "Good — Minor improvements possible",
  grade_c: "Fair — Could save you {amount}/month",
  grade_d: "Needs attention — Wasting {amount}/month",

  // Pricing
  savings_rate: "Your savings rate",
  qnneal_fee: "QNNEAL fee (10% of savings)",
  net_savings: "Your net savings",

  // Errors
  error_generic: "Something went wrong. We're on it.",
  error_no_agents: "No agents connected yet. Let's set one up!",
  error_no_workflow: "No workflow to optimize. Create one first.",

  // View modes
  view_money: "Money",
  view_manager: "Manager",
  view_engineer: "Engineer",
};

// Token-to-dollar rates per token (avg input/output)
const MODEL_RATES = {
  "gpt-5.2": 0.000005,
  "gpt-4o": 0.0000025,
  "gpt-4o-mini": 0.00000015,
  "claude-sonnet": 0.000003,
  "claude-haiku": 0.00000025,
  "gemini-3-flash": 0.0000005,
  "gemini-3-pro": 0.00000125,
  "local": 0.0000001,
  "default": 0.000002,
};

export function tokensToDollars(tokens, model) {
  const rate = MODEL_RATES[model] || MODEL_RATES["default"];
  return tokens * rate;
}

export function efficiencyToGrade(efficiency) {
  if (efficiency >= 90) return "A";
  if (efficiency >= 80) return "A-";
  if (efficiency >= 75) return "B+";
  if (efficiency >= 70) return "B";
  if (efficiency >= 65) return "B-";
  if (efficiency >= 60) return "C";
  return "D";
}

export function gradeColor(grade) {
  if (grade.startsWith("A")) return "var(--qn-grade-a)";
  if (grade.startsWith("B")) return "var(--qn-grade-b)";
  if (grade === "C") return "var(--qn-grade-c)";
  return "var(--qn-grade-d)";
}

export function gradeBorderColor(grade) {
  if (grade.startsWith("A")) return "var(--qn-grade-a)";
  if (grade.startsWith("B")) return "var(--qn-grade-b)";
  if (grade === "C") return "var(--qn-grade-c)";
  return "var(--qn-grade-d)";
}

export function formatDollars(amount) {
  if (amount >= 1000) return `$${(amount / 1000).toFixed(1)}k`;
  if (amount >= 1) return `$${amount.toFixed(2)}`;
  if (amount >= 0.01) return `$${amount.toFixed(2)}`;
  return `$${amount.toFixed(4)}`;
}

export function formatTrend(value) {
  if (value > 0) return `+${value}%`;
  if (value < 0) return `${value}%`;
  return "0%";
}

export function timeAgo(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const now = new Date();
  const diff = Math.floor((now - date) / 1000);
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return date.toLocaleDateString();
}
